<template>
  <rkm-data-table
    :fields="fields"
    :repository="repositories.aviso"
    ref="DataTable"
    :searchTable="true"
  >
    <template v-slot:cell(isAtivo)="{ item }">
      <div v-if="item.isAtivo">
        <rkm-badge color="success">Ativados</rkm-badge>
      </div>
      <div v-else>
        <rkm-badge color="danger">Desativados</rkm-badge>
      </div>
    </template>
    <template v-slot:cell(actions)="{ item }">
      <rkm-button
        @click.stop="handleMudarStatus(item)"
        color="secondary"
        small
        :title="item.isAtivo ? `Desativar agendamentos` : `Ativar agendamentos`"
      >
        <rkm-icon :icon="item.isAtivo ? `toggle-on` : `toggle-off`" />
      </rkm-button>
      <rkm-button
        @click.stop="handleEnviar(item)"
        color="success"
        small
        title="Enviar"
      >
        <rkm-icon icon="paper-plane" />
      </rkm-button>
      <rkm-button
        @click.stop="
          $router.push({
            name: 'painel-senha-aviso-edit',
            params: { id: item.id },
          })
        "
        color="primary"
        small
        title="Editar"
      >
        <rkm-icon icon="pen" />
      </rkm-button>
      <rkm-button
        @click="handleDestroy(item)"
        color="danger"
        small
        title="Excluir"
      >
        <rkm-icon icon="trash" />
      </rkm-button>
    </template>
  </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from "@/mixins";

export default {
  created() {
    this.repositories = {
      aviso: this.getConectaSusRepository("painelSenha.aviso"),
    };
  },
  data: () => ({
    fields: [
      {
        key: "mensagem",
        label: "Mensagem",
        name: "mensagem",
        searchable: true,
        sortable: true,
      },
      {
        key: "unidades",
        label: "Unidades",
        name: "unidades",
        searchable: true,
        sortable: true,
      },
      {
        key: "isAtivo",
        label: "Agendamentos",
        name: "isAtivo",
        searchable: true,
        sortable: true,
      },
      { key: "actions", label: "Ações", name: "actions", class: "col-min" },
    ],
  }),
  methods: {
    handleDestroy({ id }) {
      const destroy = () =>
        this.repositories.aviso
          .destroy(id)
          .then(() => this.$refs.DataTable.refresh());

      this.showDeleteConfirmation(
        "Deseja realmente excluir o aviso?",
        destroy,
        this.handleError
      );
    },
    handleEnviar(item) {
      this.repositories.aviso
        .send(item)
        .then(() => {
          this.showSaveNotification("Aviso enviado com sucesso!");
        })
        .catch(this.handleError);
    },
    handleMudarStatus({ id }) {
      this.repositories.aviso
        .mudarStatus(id)
        .then(() => {
          this.$refs.DataTable.refresh();
        })
        .catch(this.handleError);
    },
  },
  mixins: [repository, error],
};
</script>